/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

import type { BoundsObj, BoxTuple, Coords, MaybeNullBoundsObj } from '../../types'
import { getQueryBounds } from './getQueryBounds'

/**
 * get the center of a box {String|Object|MapBounds}
 *
 */
export function getBoxCenter(box: null | undefined): undefined
export function getBoxCenter(box: string): Coords | undefined
export function getBoxCenter(box: BoxTuple): Coords
export function getBoxCenter(box: BoundsObj): Coords
export function getBoxCenter(
  box: MaybeNullBoundsObj | BoxTuple | string | null | undefined
): Coords | undefined
export function getBoxCenter(box: MaybeNullBoundsObj | BoxTuple | string | null | undefined) {
  if (!box) {
    return undefined
  }
  const bounds = getQueryBounds(box)
  if (!bounds) {
    return undefined
  }

  if (!bounds.maxLat || !bounds.minLat || !bounds.minLng || !bounds.maxLng) {
    return undefined
  }

  const { minLat, minLng, maxLat, maxLng } = bounds
  const lat = (minLat + maxLat) * 0.5
  const lngAvg = (minLng + maxLng) * 0.5
  let lng = lngAvg
  if (minLng > maxLng) {
    if (lngAvg >= 0) {
      lng = lngAvg - 180
    } else {
      lng = lngAvg + 180
    }
  }
  return { lat, lng }
}
